import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { AppConstants } from './core/constants/constants';
import { PermissionGuard } from 'app/core/auth/guards/permission.guard';
import { PERMISSIONS } from 'app/core/auth/auth-types';

export const appRoutes: Route[] = [

    { path: '', pathMatch: 'full', redirectTo: AppConstants.dashboard },

    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: AppConstants.dashboard },

    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: AppConstants.forgotPassword, loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: AppConstants.resetPassword, loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: AppConstants.signIn, loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: AppConstants.signUp, loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') },
            { path: AppConstants.activateAdminAccount, loadChildren: () => import('app/modules/auth/activate-admin-account/activate-admin-account-routes') },
            { path: AppConstants.activateAdminAccount, loadChildren: () => import('app/modules/auth/activate-admin-account/activate-admin-account-routes') },
            { path: AppConstants.activateCustomerAccount, loadChildren: () => import('app/modules/auth/activate-customer-account/activate-customer-account-routes') },
            { path: 'accept-invitation', loadChildren: () => import('app/modules/auth/accept-invitation/accept-invitation.routes') },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: AppConstants.signOut, loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'access-denied', loadChildren: () => import('app/modules/auth/access-denied/access-denied.routes') },
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'dense'
        },
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: AppConstants.dashboard, loadChildren: () => import('app/modules/dashboard/dashboard-routes') },
            { path: AppConstants.example, loadChildren: () => import('app/modules/example/example.routes') },
            {
                path: AppConstants.productFamily,
                canActivate: [PermissionGuard],
                data: { permissions: [PERMISSIONS.PRODUCT_READ] },
                loadChildren: () => import('app/modules/product-family/product-family-routes')
            },
            {
                path: AppConstants.products,
                canActivate: [PermissionGuard],
                data: { permissions: [PERMISSIONS.PRODUCT_READ] },
                loadChildren: () => import('app/modules/products/products-routes')
            },
            {
                path: AppConstants.inventoryReconciliation,
                canActivate: [PermissionGuard],
                data: { permissions: [PERMISSIONS.RECONCILIATION_READ] },
                loadChildren: () => import('app/modules/inventory-reconciliation/reconciliation-routes')
            },
            {
                path: 'company',
                canActivate: [PermissionGuard],
                data: { permissions: [PERMISSIONS.COMPANY_READ] },
                loadChildren: () => import('app/modules/company/company.routes')
            },
            { path: AppConstants.profile, loadChildren: () => import('app/modules/profile/profile-routes') },
            {
                path: AppConstants.customers,
                canActivate: [PermissionGuard],
                data: { permissions: [PERMISSIONS.CUSTOMER_READ] },
                loadChildren: () => import('app/modules/customers/customers-routes')
            },
            {
                path: AppConstants.suppliers,
                canActivate: [PermissionGuard],
                data: { permissions: [PERMISSIONS.SUPPLIER_READ] },
                loadChildren: () => import('app/modules/suppliers/suppliers-routes')
            },
            {
                path: AppConstants.sales,
                canActivate: [PermissionGuard],
                data: {
                    permissions: [PERMISSIONS.SALE_ORDER_READ, PERMISSIONS.SALES_QUOTATION_READ],
                    permissionMode: 'any'
                },
                loadChildren: () => import('app/modules/sales/sales-routes')
            },
            {
                path: AppConstants.purchaseOrders,
                canActivate: [PermissionGuard],
                data: { permissions: [PERMISSIONS.PURCHASE_ORDER_READ] },
                loadChildren: () => import('app/modules/purchase-orders/purchase-orders-routes')
            },
            {
                path: AppConstants.discounts,
                canActivate: [PermissionGuard],
                data: { permissions: [PERMISSIONS.DISCOUNT_READ] },
                loadChildren: () => import('app/modules/discounts/discount.routes')
            },
            {
                path: AppConstants.marketing,
                canActivate: [PermissionGuard],
                data: { permissions: [PERMISSIONS.MARKETPLACE_READ], permissionMode: 'any' },
                loadChildren: () => import('app/modules/marketing/marketing.routes')
            },
            {
                path: AppConstants.team,
                canActivate: [PermissionGuard],
                data: { permissions: [PERMISSIONS.ROLE_READ, PERMISSIONS.TEAM_READ], permissionMode: 'any' },
                loadChildren: () => import('app/modules/team/team.routes')
            }
        ]
    },

    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: AppConstants.notFound, loadChildren: () => import('app/modules/auth/error-404/error-404.routes') },
            { path: '**', redirectTo: AppConstants.notFound }
        ]
    }
];
